import { render, staticRenderFns } from "./QuizLeaderboard.vue?vue&type=template&id=437a1ddc&"
import script from "./QuizLeaderboard.vue?vue&type=script&lang=js&"
export * from "./QuizLeaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports